import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators } from '@angular/forms';

@Component({
    selector: 'rr-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextareaComponent),
            multi: true,
        }
    ]
})
export class TextareaComponent implements ControlValueAccessor, OnInit, OnChanges {
    @Input() label: string = '';
    FormControl: FormControl = new FormControl();
    @Input() placeholder: string = '';
    @Output() change: EventEmitter<any> = new EventEmitter();
    @Input() disabled: boolean = false;
    @Input() required: boolean = false;
    @Input() value: any = '';

    @Input() btnType: string | undefined;
    @Input() btnText: string = '';
    @Input() btnIconStart: string = '';
    @Input() btnIconEnd: string = '';
    @Output() btnClick: EventEmitter<any> = new EventEmitter();

    errorClass: string = '';
    internValue: any;
    btnDisabeld: boolean = false;

    ngOnInit() {
        if (this.required) {
            this.FormControl.setValidators(Validators.required);
        }
        if (this.FormControl) {
            this.value = this.FormControl.value;
            this.FormControl.valueChanges.subscribe((value) => {
                this.value = value;
                this.onChange(value);
                this.change.emit(value);
            });
        }
        this.checkValidation();
        this.chekValue()
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['value'] && changes['value'].currentValue !== undefined) {
            this.value = changes['value'].currentValue;
            this.FormControl.setValue(this.value);
        }
        if (changes['required']) {
            //   console.log('changes', this.value);
            if (changes['required'].currentValue === true) {
                setTimeout(() => {
                    // this.btnDisabeld = true;
                    this.chekValue();
                }, 0);
            }
        }

    }

    writeValue(value: any): void {
        this.internValue = value;
        this.FormControl.setValue(value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onBtnClick() {
        if (this.required === true && this.value === '') {
            return;
        }

        this.btnClick.emit(this.value);
    }

    chekValue() {
        if (this.required === true && (this.value === '' || !this.value)) {
            this.btnDisabeld = true;
        } else {
            this.btnDisabeld = false;
        }
    }

    onChange: any = () => { };
    onTouched: any = () => { };

    async checkValidation() {
        if (this.required) {
            this.FormControl.setValidators([Validators.required]);
        }

        this.FormControl.updateValueAndValidity();
        if (this.FormControl.invalid) {
            this.errorClass = 'error';
            return false;
        }
        this.errorClass = '';
        return true;
    }
}
